module.exports = __webpack_public_path__ + "static/media/bg-lucky.0e222b2a.png";